export const containerStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '16px 16px 16px 20px',
  margin: '0 16px 8px',
  borderRadius: '4px 8px 8px 4px',
  backgroundColor: ({ palette }) => palette.info.extraSoft ?? palette.info.light,
  boxShadow: ({ palette }) => palette.shadow.l,
  overflow: 'hidden',
  position: 'relative',
  flexShrink: 0,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '4px',
    backgroundColor: ({ palette }) => palette.info.dark,
    borderRadius: '4px 0 0 4px',
  },
};

export const iconStyles = {
  display: 'flex',
  flexShrink: 0,
  color: ({ palette }) => palette.info.main,
};
